export default __webpack_public_path__ + "static/media/S_CoreDream_7ExtraBold.7d4b5dea.woff";